export default __webpack_public_path__ + "static/media/tree.2ad6abd9.png";